import { urls, request } from '../utils';
import getHeaders from './getHeaders';

export async function clientsListRequest(urlParams = {}) {
  let url = urls.clientsList;

  if (urlParams.page) {
    url = urls.clientsListPsf;
  }

  return request({
    method: 'get',
    url,
    urlParams,
    headers: getHeaders(),
  });
}

export async function clientsItemRequest(urlParams = {}) {
  const url = urls.clientsItem;
  return request({ method: 'get', url, urlParams, headers: getHeaders() });
}

export async function clientsDefaultRequest(urlParams = {}) {
  const url = urls.clientsDefault;
  return request({ method: 'get', url, urlParams, headers: getHeaders() });
}

export async function clientsUiSettingsRequest(urlParams = {}) {
  const url = urls.clientsUiSettings;
  return request({ method: 'get', url, urlParams, headers: getHeaders() });
}

export async function clientsCreateRequest(data) {
  return request({
    method: 'post',
    url: urls.clientsCreate,
    data,
    headers: getHeaders(),
  });
}

export async function clientsUpdateRequest(urlParams, data) {
  return request({
    method: 'put',
    url: urls.clientsUpdate,
    urlParams,
    data,
    headers: getHeaders(),
  });
}

export async function clientsDeleteRequest(urlParams) {
  return request({
    method: 'delete',
    url: urls.clientsDelete,
    urlParams,
    headers: getHeaders(),
  });
}

export async function clientsRecognitionUsagesRequest(urlParams = {}) {
  const url = urls.clientsRecognitionUsages;
  return request({ method: 'get', url, urlParams, headers: getHeaders() });
}



// WEBPACK FOOTER //
// ./src/services/clients.js